import { render, staticRenderFns } from "./ServiceTask.vue?vue&type=template&id=5902ef71&"
import script from "./ServiceTask.vue?vue&type=script&lang=js&"
export * from "./ServiceTask.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports